module.exports = __webpack_public_path__ + "static/frontpage-hero-background-1200-cc04d43e0b81da4dd86597434e57ab5c.jpg";